/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/UI/Setup',[
    'jquery',
    'global/Logger',
    'plugins/affix',
    'plugins/jquery.truncator',
    'plugins/collapse',
    'plugins/tab',
    'plugins/a11ytoggle',
    'plugins/dismissable',
    'plugins/slick'
], function ($, Logger, Navigation, affix, truncator, collapse, tab, a11ytoggle, Slick) {
    'use strict';

    Logger.debug('Setting up JS Plugins...');
	
	var other$ = jQuery;
		
	
    // When the user scrolls the page, execute myFunction 
    window.onscroll = function () { headerScroll() };	
	// Get the navbar
    var navbar = document.getElementById("nav");
    // Get the offset position of the navbar
    if (navbar) {
        var sticky = navbar.offsetTop;
    }
    // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function headerScroll() {
        headerStickyCheck();
    }
    headerStickyCheck();
    function headerStickyCheck() {
        if (navbar) {
            if (window.pageYOffset >= sticky) {
                navbar.classList.add("sticky");                
            } else {
                navbar.classList.remove("sticky");
            }
        }
    }			
	
	/** Button/Anchor Keyboard User Fix **/
	function a11yClick(event) {
		if (event.type === 'click' || event.type === 'touchstart') {
			return true;
		}
		else if (event.type === 'keypress') {
			var code = event.charCode || event.keyCode;
			if (code === 32) {
				event.preventDefault();
			}
			if ((code === 32) || (code === 13)) {
				return true;
			}
		}
		else {
			return false;
		}
	}

    $(function () {
		
		$(".navSpan dl.link-list dt").click(function(){
			$(this).parent(".link-list").toggleClass("open"); 
			$('html, body').animate({ scrollTop: jQuery(this).offset().top - 170 }, 1500 );
		});
		
        // Workaround regarding targetblank vulnerability, for more details see: https://dev.to/ben/the-targetblank-vulnerability-by-example
        $('a[target=_blank], a[target=new]').attr('rel', 'noopener noreferrer');

        // functionality for hidden/expandable content
        $('.siteBody').on('click', '.expandable-trigger', function (e) {
            var trigger = $(e.currentTarget);
            trigger.find('.icon-plus-circle').toggleClass('icon-minus-circle');
            trigger.next('.expandable').toggleClass('expanded');
        });

        // sticky recently viewed (for large screens)
		other$('#recently-viewed').affix({
            offset: {
                top: function () {
                    return (this.top = $('#recently-viewed').offset().top - 70);
                },
                bottom: function () {
                    return (this.bottom = $('.footer').outerHeight(true) + 30);
                }
            }
        });

//        $('#sticky-nav').affix({
//            offset: {
//                top: function () {
//                    return (this.top = $('#sticky-nav').offset().top - $('.roc-navbar-impersonation').outerHeight(true));
//                }
//            }
//        }).on('affix.bs.affix', function(e) {
//            var toolbar = $('.roc-navbar-impersonation');
//
//            if ((toolbar.length > 0) && window.matchMedia("(min-width: 940px)").matches) {
//                var fixedOffset = toolbar.outerHeight(true);
//                var stickyNav = $(e.currentTarget); 
//
//                stickyNav.css('top', fixedOffset);
//                stickyNav.on('affix-top.bs.affix', function(e) {
//                    if (toolbar.length > 0) {
//                        stickyNav.css('top', '0')
//                    };
//                });
//            };
//        });


        $('.saved-carts-carousel-wrapper').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 2600,
                    settings: "unslick"
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: true
                    }
                }
            ]
        });
		
		// Slick slider Homepage New
        $('.homepage-hero-banners-list').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			fade: true,
			adaptiveHeight: true
        });		

        // use 'data-hijax' to prevent navigation to href
        $('body').on('click', '[data-hijax="true"]', function (e) {
            e.preventDefault();
        });
        
        // set up collapse extensions
        $('body').on('show.bs.collapse', '[data-auto-collapse="true"]', function(e){
            $('body').on('click', collapseAutoClose);
        }).on('hidden.bs.collapse', '.collapse', function(e){
            $('body').off('click', collapseAutoClose);
        });
        
        function collapseAutoClose(e) {
            if ($(e.target).closest('[data-auto-collapse="true"]').length === 0) {
                $('[data-auto-collapse="true"].in').collapse('hide');
            };
        };

        $('#favorites-toolbar-content').on('show.bs.collapse', function (e) {
            var toolbarTrigger = $('.roc-favoritesToolbar .roc-moduleHeader .btnText'),
                toolbarTriggerText = toolbarTrigger.find('.changeText');
            toolbarTriggerText.text(toolbarTrigger.data('textExpanded'));
        }).on('hidden.bs.collapse', function (e) {
            var toolbarTrigger = $('.roc-favoritesToolbar .roc-moduleHeader .btnText'),
                toolbarTriggerText = toolbarTrigger.find('.changeText');
            toolbarTriggerText.text(toolbarTrigger.data('textCollapsed'));
        });

		other$('.truncate').truncate({
            max_length: 400,
            more: 'read more',
            less: 'read less'
        });
		
		$(".toggle-search").each(function () {
			var $toggle = $(this);

			$toggle.on("click keypress", function (e) {
//				$('html').toggleClass("search-active");
				if (a11yClick(e) === true) {
					e.preventDefault();
					var $trigger = $(this);

					$("html").off("click touchstart focusin", searchToggleHandler);

                    var $autoAppSiteContainer = $('.portal-siteContent');
                    var $formeeSiteSearch = $('.formee-group.siteSearch');

					if ($trigger.hasClass("active")) {
						$trigger.removeClass("active");
                        $autoAppSiteContainer.removeClass("search-open");
                        $formeeSiteSearch.removeClass("search-open");
						$(".siteSearch").slideUp(function () {
							$trigger.find("span span").html("Open");
						});
					} else {
						$trigger.addClass("active").find("span span").html("Close");
						$(".siteSearch").fadeIn(function () {
							var $search = $(this);
                            $autoAppSiteContainer.addClass("search-open");
                            $formeeSiteSearch.addClass("search-open");
							setTimeout(function () {
								$search.find("input").first().focus();
							}, 300);
						}).css('display','flex');

						$("html").on("click touchstart focusin", searchToggleHandler);
					}
				}
			});

			function searchToggleHandler(e) {
				var $target = $(e.target);
				if ($target.closest(".siteSearch").length <= 0 && $target.closest(".toggle-search").length <= 0 && !$target.hasClass("toggle-search")) {
					$toggle.trigger("click");
				}

			};

		});
		
//		$('#product-accordion .nav-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
//			//new tab
//			console.log(e.target);
//
//			//previous tab
//			console.log(e.relatedTarget);
//		})
		
		//"Simplified" Tabcordion		
		$(".tab_content").css('display', 'none');
		$(".tab_content:first").css('display', 'block');
		/* Desktop Tab Mode */
		$("ul.tabs li").click(function() {
			
		    //$(".tab_content").hide();
		    $(".tab_content").css('display','none');
			var activeTab = $(this).attr("rel"); 
			$("#"+activeTab).fadeIn();		

			$("ul.tabs li").removeClass("active");
			$(this).addClass("active");
			$(this).next('.tab_content').css('display', 'block');

			$(".tab_drawer_heading").removeClass("d_active");
			$(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

		
		    //add  storage code here 
			var activetab= $(this).attr("data-tabid");
			localStorage.setItem("ActiveTabID", activetab);

			var activecategory= $('div.breadcrumbs').find("span[title]").text();
			localStorage.setItem("ActiveCategory", activecategory);

		});
		$(".tab_container").css("min-height", function(){ 
			return $(".tabs").outerHeight() + 50;
		});
        /* Mobile Drawer Mode */

		$(".tab_drawer_heading").click(function () {
		    var d_activeTab = $(this).attr("rel");

		    if ($(this).hasClass("d_active")) {
		        $("#" + d_activeTab).hide();
		        $(this).removeClass("d_active");
		    }
		    else {
		        $(".tab_content").css('display', 'none');
		        $("#" + d_activeTab).fadeIn();

		        $(".tab_drawer_heading").removeClass("d_active");

		        $(this).addClass("d_active");
		        $(this).next('.tab_content').css('display', 'block');

		        $("ul.tabs li").removeClass("active");
		        $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");

		    }
			
		    //$(".tab_content").hide();
		    //$(".tab_content").css('display', 'none');
			//var d_activeTab = $(this).attr("rel"); 
			//$("#"+d_activeTab).fadeIn();

			//$(".tab_drawer_heading").removeClass("d_active");
			//$(this).addClass("d_active");
			//$(this).next('.tab_content').css('display', 'block');

			//$("ul.tabs li").removeClass("active");
			//$("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
		});


		$('#modal-btn-01').magnificPopup({
			items: {
				src: '#modal-01',
				type: 'inline'
			}
        });

        // branch locator
        $("#hideLocationListBtn").click(function () {
            $(this).toggleClass("hidden");
            $(this).siblings().toggleClass("hidden")
            $("#location-list").hide();
        });

        $("#showLocationListBtn").click(function () {
            $(this).toggleClass("hidden");
            $(this).siblings().toggleClass("hidden")
            $("#location-list").show();
        });
		
		var mq = window.matchMedia( "(max-width: 767px)" );

		if (mq.matches) {
			$(".homepage-hero .bannerImage .container").matchHeights();
			$(".homepage-hero .homepage-hero-content").matchHeights();

            $(".portal-hero .bannerImage .container").matchHeights();
            $(".portal-hero .portal-hero-button").matchHeights();
		}
		
		var TabCollapse = function (el, options) {
			this.options   = options;
			this.$tabs  = $(el);

			this._accordionVisible = false; //content is attached to tabs at first
			this._initAccordion();
			this._checkStateOnResize();


			// checkState() has gone to setTimeout for making it possible to attach listeners to
			// shown-accordion.bs.tabcollapse event on page load.
			// See https://github.com/flatlogic/bootstrap-tabcollapse/issues/23
			var that = this;
			setTimeout(function() {
				that.checkState();
			}, 0);
		};

		TabCollapse.DEFAULTS = {
			accordionClass: 'visible-xs',
			tabsClass: 'hidden-xs',
			accordionTemplate: function(heading, groupId, parentId, active) {
				return  '<div class="panel panel-default">' +
					'   <div class="panel-heading">' +
					'      <h4 class="panel-title">' +
					'      </h4>' +
					'   </div>' +
					'   <div id="' + groupId + '" class="panel-collapse collapse ' + (active ? 'in' : '') + '">' +
					'       <div class="panel-body js-tabcollapse-panel-body">' +
					'       </div>' +
					'   </div>' +
					'</div>'

			}
		};

		TabCollapse.prototype.checkState = function(){
			if (this.$tabs.is(':visible') && this._accordionVisible){
				this.showTabs();
				this._accordionVisible = false;
			} else if (this.$accordion.is(':visible') && !this._accordionVisible){
				this.showAccordion();
				this._accordionVisible = true;
			}
		};

		TabCollapse.prototype.showTabs = function(){
			var view = this;
			this.$tabs.trigger($.Event('show-tabs.bs.tabcollapse'));

			var $panelHeadings = this.$accordion.find('.js-tabcollapse-panel-heading').detach();

			$panelHeadings.each(function() {
				var $panelHeading = $(this),
					$parentLi = $panelHeading.data('bs.tabcollapse.parentLi');

				var $oldHeading = view._panelHeadingToTabHeading($panelHeading);

				$parentLi.removeClass('active');
				if ($parentLi.parent().hasClass('dropdown-menu') && !$parentLi.siblings('li').hasClass('active')) {
					$parentLi.parent().parent().removeClass('active');
				}

				if (!$oldHeading.hasClass('collapsed')) {
					$parentLi.addClass('active');
					if ($parentLi.parent().hasClass('dropdown-menu')) {
						$parentLi.parent().parent().addClass('active');
					}
				} else {
					$oldHeading.removeClass('collapsed');
				}

				$parentLi.append($panelHeading);
			});

			if (!$('li').hasClass('active')) {
				$('li').first().addClass('active')
			}

			var $panelBodies = this.$accordion.find('.js-tabcollapse-panel-body');
			$panelBodies.each(function(){
				var $panelBody = $(this),
					$tabPane = $panelBody.data('bs.tabcollapse.tabpane');
				$tabPane.append($panelBody.contents().detach());
			});
			this.$accordion.html('');

			if(this.options.updateLinks) {
				var $tabContents = this.getTabContentElement();
				$tabContents.find('[data-toggle-was="tab"], [data-toggle-was="pill"]').each(function() {
					var $el = $(this);
					var href = $el.attr('href').replace(/-collapse$/g, '');
					$el.attr({
						'data-toggle': $el.attr('data-toggle-was'),
						'data-toggle-was': '',
						'data-parent': '',
						href: href
					});
				});
			}

			this.$tabs.trigger($.Event('shown-tabs.bs.tabcollapse'));
		};

		TabCollapse.prototype.getTabContentElement = function(){
			var $tabContents = $(this.options.tabContentSelector);
			if($tabContents.length === 0) {
				$tabContents = this.$tabs.siblings('.tab-content');
			}
			return $tabContents;
		};

		TabCollapse.prototype.showAccordion = function(){
			this.$tabs.trigger($.Event('show-accordion.bs.tabcollapse'));

			var $headings = this.$tabs.find('li:not(.dropdown) [data-toggle="tab"], li:not(.dropdown) [data-toggle="pill"]'),
				view = this;
			$headings.each(function(){
				var $heading = $(this),
					$parentLi = $heading.parent();
				$heading.data('bs.tabcollapse.parentLi', $parentLi);
				view.$accordion.append(view._createAccordionGroup(view.$accordion.attr('id'), $heading.detach()));
			});

			if(this.options.updateLinks) {
				var parentId = this.$accordion.attr('id');
				var $selector = this.$accordion.find('.js-tabcollapse-panel-body');
				$selector.find('[data-toggle="tab"], [data-toggle="pill"]').each(function() {
					var $el = $(this);
					var href = $el.attr('href') + '-collapse';
					$el.attr({
						'data-toggle-was': $el.attr('data-toggle'),
						'data-toggle': 'collapse',
						'data-parent': '#' + parentId,
						href: href
					});
				});
			}

			this.$tabs.trigger($.Event('shown-accordion.bs.tabcollapse'));
		};

		TabCollapse.prototype._panelHeadingToTabHeading = function($heading) {
			var href = $heading.attr('href').replace(/-collapse$/g, '');
			$heading.attr({
				'data-toggle': 'tab',
				'href': href,
				'data-parent': ''
			});
			return $heading;
		};

		TabCollapse.prototype._tabHeadingToPanelHeading = function($heading, groupId, parentId, active) {
			$heading.addClass('js-tabcollapse-panel-heading ' + (active ? '' : 'collapsed'));
			$heading.attr({
				'data-toggle': 'collapse',
				'data-parent': '#' + parentId,
				'href': '#' + groupId
			});
			return $heading;
		};

		TabCollapse.prototype._checkStateOnResize = function(){
			var view = this;
			$(window).resize(function(){
				clearTimeout(view._resizeTimeout);
				view._resizeTimeout = setTimeout(function(){
					view.checkState();
				}, 100);
			});
		};


		TabCollapse.prototype._initAccordion = function(){
			var randomString = function() {
				var result = "",
					possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
				for( var i=0; i < 5; i++ ) {
					result += possible.charAt(Math.floor(Math.random() * possible.length));
				}
				return result;
			};

			var srcId = this.$tabs.attr('id'),
				accordionId = (srcId ? srcId : randomString()) + '-accordion';

			this.$accordion = $('<div class="panel-group ' + this.options.accordionClass + '" id="' + accordionId +'"></div>');
			this.$tabs.after(this.$accordion);
			this.$tabs.addClass(this.options.tabsClass);
			this.getTabContentElement().addClass(this.options.tabsClass);
		};

		TabCollapse.prototype._createAccordionGroup = function(parentId, $heading){
			var tabSelector = $heading.attr('data-target'),
				active = $heading.data('bs.tabcollapse.parentLi').is('.active');

			if (!tabSelector) {
				tabSelector = $heading.attr('href');
				tabSelector = tabSelector && tabSelector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
			}

			var $tabPane = $(tabSelector),
				groupId = $tabPane.attr('id') + '-collapse',
				$panel = $(this.options.accordionTemplate($heading, groupId, parentId, active));
			$panel.find('.panel-heading > .panel-title').append(this._tabHeadingToPanelHeading($heading, groupId, parentId, active));
			$panel.find('.panel-body').append($tabPane.contents().detach())
				.data('bs.tabcollapse.tabpane', $tabPane);

			return $panel;
		};



		// TABCOLLAPSE PLUGIN DEFINITION
		// =======================

		$.fn.tabCollapse = function (option) {
			return this.each(function () {
				var $this   = $(this);
				var data    = $this.data('bs.tabcollapse');
				var options = $.extend({}, TabCollapse.DEFAULTS, $this.data(), typeof option === 'object' && option);

				if (!data) { 
					$this.data('bs.tabcollapse', new TabCollapse(this, options));
				}
			});
		};

		$.fn.tabCollapse.Constructor = TabCollapse;
		
		$('#pdpTab').tabCollapse();

		/* Ticket Details: #668744: Revamping our Automotive Industry Page */

		$(".accordion-button").on("click", function(e) {
			e.preventDefault();
			var $this = $(this);
			if (!$this.hasClass("accordion-active")) {
				$(".accordion-content").slideUp(200);
				$(".accordion-button").removeClass("accordion-active").attr('aria-expanded', "false");
			}
			$this.toggleClass("accordion-active").attr('aria-expanded', "true");
			$this.next().slideToggle();
		});	


    });

    // This is required to fix an issue in earlier versions of Windows Phone 8
    // http://timkadlec.com/2013/01/windows-phone-8-and-device-width/
    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
        var msViewportStyle = document.createElement('style');
        msViewportStyle.appendChild(
          document.createTextNode(
            '@-ms-viewport{width:auto!important}'
          )
        );
        document.querySelector('head').appendChild(msViewportStyle);
    }

	$(document).ready(function(){	
	  if ($(".pdf-box-table-text").length > 0) {
		$('.popup-video-play').magnificPopup({
			disableOn: 700,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false,
			callbacks: {
			   markupParse: function(template, values, item) {
				   template.find('iframe').attr('allow','autoplay');
			   }
			}						
		});
	  }		
	});	
	
    var Setup = {};

    return Setup;
    
});

